import bg from './coupon-bg.png';
import {useTranslation} from "react-i18next";
import CouponCardHOC from "../../../../publicComponent/CouponCardHOC";
import Button from "../../../../publicComponent/Button";
import Dialog from "../../../../publicComponent/Dialog";

function CouponCard({ data, className, button = null, theme, getCoupon }) {
  const { t } = useTranslation();
  
  const couponQRCode = (qrcode) => {
    Dialog.qrcode({
      title: 'Coupon',
      qrcode,
      qrcodeType:'content',
      showClose: true
    });
  };
  
  return (
    <div
      className={`relative inline-block overflow-hidden mdmax:container ${className}`}>
      <img className="absolute top-0 left-0"
           style={{ height: '100%', width: '100%' }}
           src={bg}/>
      <div className="flex relative z-10">
        <div className="justify-center items-center flex flex-col overflow-hidden relative
                         pr-[10px] pl-[15px] w-[35%] xl:min-h-[138px] min-h-[112px]">
          {
            data.couponType == 1 || data.couponType == 3 || data.couponType == 4 ?
              <p className="text-[34px] text-white font-bold z-10"
                 style={{ color: data.sendTotalQty > data.takenTotalQty ? '#eece7a' : '#ccc' }}>
                ${data.thresholdValue}
              </p> : null
          }
          
          {
            data.couponType == 2 ?
              <p className="text-[34px] text-white font-bold z-10"
                 style={{ color: data.sendTotalQty > data.takenTotalQty ? '#eece7a' : '#ccc' }}>
                {data.thresholdValue}{t('折')}
              </p> : null
          }
          <p className="text-base text-white z-10 text-center"
             style={{ color: data.sendTotalQty > data.takenTotalQty ? '#eece7a' : '#ccc' }}>
            {
              data.thresholdAmount > 0
                ? `${t('满')} $${data.thresholdAmount}
                      ${t('可用')}`
                : t('无限制使用')
            }
          </p>
        </div>
        <div className="flex-1 xl:min-h-[138px] min-h-[112px] xl:py-[18px] py-[8px] border-l-[0px]
                        xl:px-[20px] px-[5px] mdmax:pl-[10px]">
          <p className="text-base text-white">
            {t('限商品')}：
            {data.goodsRangeType === 1 ? t('全商品可用') : t('部分商品可用')}
          </p>
          
          <p className={`text-base text-white mt-[2px] ${data.type !== '0' && data.type ? 'mb-0' : 'mb-[10px]'}`}>
            {t('限商家')}：
            {data.cabinetLimitType === 1 ? t('全商家可用') : t('部分商家可用')}
          </p>
          {data.type !== '0' && data.type
          && <p className="text-base truncate mt-[2px] mb-[5px]">{t('消耗积分')}: {data.point}分</p>}
          {button}
          <Button className="px-[10px] text-[13px] py-[3px] bg-[#ddd] cursor-not-allowed
                rounded-[99px] w-[80px] ml-[10px]"
                  onClick={() => couponQRCode(data.id)}>QR code</Button>
        </div>
      </div>
    </div>
  );
}

export default CouponCardHOC(CouponCard);
